import { Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { USER_PAGE_TOAST } from "common/Constants/UserPageToast.constants";
import PageTitle from "common/Components/PageTitle/PageTitle";
import { lazy, Suspense } from "react";
import { usePlatformUserAccessInitialization } from "./PlatformUserAccess.hook";
import UserAccessList from "./components/UserAccessList";
import InviteUserModal from "./components/InviteUserModal";
import UserAccessDetailPanel from "./components/UserAccessDetailPanel";
import { PLATFORM_USER_ACCESS_UI } from "./PlatformUserAccess.constants";
import {
  ErrorAlertContainer,
  PageContainer,
  PageInviteButton,
} from "./PlatformUserAccess.styles";

const Toast = lazy(() => import("common/Components/Toast"));

const PlatformUserAccess = () => {
  const {
    state,
    customerRoleOptions,
    activeCustomers,
    actions,
    toast,
    dismissToast,
  } = usePlatformUserAccessInitialization();

  const platformRoleOptions =
    INFRAMARK_CONSTANTS?.users?.constants?.platformRoles ?? [];

  return (
    <PageContainer>
      <Suspense fallback={null}>
        <Toast
          type={toast.type}
          title={toast.title}
          description={toast.description}
          show={toast.show}
          onClose={dismissToast}
          duration={USER_PAGE_TOAST.DURATION}
        />
      </Suspense>
      {state.error && (
        <ErrorAlertContainer>
          <Alert severity="error" onClose={actions.clearError}>
            {state.error}
          </Alert>
        </ErrorAlertContainer>
      )}
      <PageTitle
        title={PLATFORM_USER_ACCESS_UI.pageTitle}
        subTitle={PLATFORM_USER_ACCESS_UI.pageSubtitle}
        icon={<VpnKeyOutlinedIcon />}
        action={
          <PageInviteButton
            type="button"
            onClick={actions.openInviteModal}
            startIcon={<AddIcon />}
          >
            {PLATFORM_USER_ACCESS_UI.inviteUserLabel}
          </PageInviteButton>
        }
      />
      <UserAccessList
        rows={state.users}
        loading={state.loading}
        pagination={state.pagination}
        listFilters={state.listFilters}
        platformRoleFilterOptions={platformRoleOptions}
        onListFiltersChange={actions.onListFiltersChange}
        onClearFilters={actions.onClearFilters}
        onPageChange={actions.onPageChange}
        onRowsPerPageChange={actions.onRowsPerPageChange}
        onRowClick={actions.loadUserDetails}
        onRowAction={actions.onUserListAction}
      />
      <UserAccessDetailPanel
        open={Boolean(state.selectedUserDetails)}
        selectedUser={state.selectedUserDetails}
        customers={activeCustomers}
        platformRoleOptions={platformRoleOptions}
        roleOptions={customerRoleOptions}
        onSave={actions.saveUserDetails}
        onCancel={actions.closeUserDetails}
        onAccessActionSuccess={actions.refreshAfterCustomerAccessAction}
        onCustomerUserListAction={actions.onCustomerUserListAction}
      />
      <InviteUserModal
        open={state.isInviteModalOpen}
        onClose={actions.closeInviteModal}
        onSubmit={actions.inviteUser}
        checkInviteEmail={actions.checkInviteEmail}
        platformRoleOptions={platformRoleOptions}
        roleOptions={customerRoleOptions}
        customers={activeCustomers}
      />
    </PageContainer>
  );
};

export default PlatformUserAccess;
